import ordinal from 'ordinal';

import {
  ELEMENTARY_SCHOOL_GRADES,
  MIDDLE_HIGH_SCHOOL_GRADES,
} from 'constants/gradeYears';

const getGradeFilterK12Only = response => {
  const allGradeYears = ELEMENTARY_SCHOOL_GRADES.concat(
    MIDDLE_HIGH_SCHOOL_GRADES,
  );
  const formattedData = response.data
    .filter(entry => allGradeYears.includes(Number(entry)))
    .sort((a, b) => Number(a) - Number(b))
    .map(entry => ({
      id: entry,
      name: entry === 0 ? 'Kindergarten' : ordinal(entry),
    }));

  return {
    key: 'grades',
    source: 'grades',
    filterName: 'Grades',
    searchable: false,
    defaultSelection: formattedData,
    options: formattedData,
    selector: 'id',
    label: 'name',
  };
};

export default getGradeFilterK12Only;
